import BaseComponent from '../BaseComponent';

const NAME = 'ImageCropper';

class ImageCropper extends BaseComponent {
  constructor(element, config = {}) {
    super(element);
    this.config = config;
  }

  static get NAME() {
    return NAME;
  }

  init() {
    this._element.style.height = '300px !important';
    this.cropper = new Cropper(this._element, {
      ...this.config,
      aspectRatio: 1 / 1,
      viewMode: 2,
      ready: () => {
        this.cropper.crop();
      }
    });
  }

  getImageURL() {
    if(!this.cropper){
      return null;
    }
    const canvas = this.cropper.getCroppedCanvas();
		return canvas.toDataURL();
  }

  getImageFile(name) {
    return new Promise((resolve, reject) => {
      if(!this.cropper) {
        reject(null);
      }
      const canvas = this.cropper.getCroppedCanvas();
      canvas.toBlob((blob) => {
        resolve(new File([blob], name));
      });
    })
  }

  destroy() {
    this.cropper.destroy();
    this._element.style.height = '';
  }

}

export default ImageCropper;